import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BpGoogleAutocompleteComponent } from "@modules/shared/bp-google-autocomplete/bp-google-autocomplete.component";
import { CoreModule } from "@modules/core/core.module";
import { HighlightDirective } from "@modules/shared/bp-google-autocomplete/bp-google-autocomplete-highligh.directive";
import { BpPlaceOfBirthAutocompleteComponent } from "@modules/shared/bp-place-of-birth-autocomplete/bp-place-of-birth-autocomplete.component";

const components = [BpPlaceOfBirthAutocompleteComponent, BpGoogleAutocompleteComponent, HighlightDirective];

@NgModule({
	declarations: [...components],
	exports: [...components],
	imports: [CommonModule, CoreModule]
})
export class BpGoogleAutocompleteModule {}
